/* @flow */
import React from 'react';
import Tabs from 'components/Tabs.jsx';
import TabPanel from 'components/TabPanel.jsx';
import Activity from 'entities/Activity';
import ActivitiesSplitView from 'payments/components/ActivitiesSplitView.jsx';

import './styles/ActivitiesClass.scss';

// typecheck: ignore statement
function split(activities: Activity[]): {owned: Activity[], invited: Activity[], all: Activity[]} {
  const all = activities;
  const owned = [];
  const invited = [];

  all.forEach(activity => {
    activity.isSender() ? owned.push(activity) : invited.push(activity); // eslint-disable-line
  });

  return { owned, invited, all };
}

type Props = {
  activities: Activity[],
  canManage: boolean,
};

type State = {
  tab: number,
}

class ActivitiesClass extends React.Component {
  props: Props;

  state: State = {
    tab: 0,
  };

  static defaultProps = {
    activities: [],
  };

  tabChangeListener = (tab: number) => {
    if (tab !== this.state.tab) {
      this.setState({ tab });
    }
  }

  render() {
    const { all, owned, invited } = split(this.props.activities);
    const activities = [all, owned, invited][this.state.tab];

    return (
      <div className="ActivitiesClass">
        {this.props.canManage &&
          <Tabs onTabChange={this.tabChangeListener}>
            <TabPanel title={<span>All</span>} />
            <TabPanel title={<span>Hosting</span>} />
            <TabPanel title={<span>Invites</span>} />
          </Tabs>
        }

        { /* tabs have a "separator" border, when no tab show this one: */}
        {!this.props.canManage && <hr className="ActivitiesClass-hr" />}

        <div className="ActivitiesClass-content">
          <ActivitiesSplitView
            activities={activities}
            nuxCanManage={this.state.tab === 2 ? false : this.props.canManage}
            /* if looking at the "Invites" tab we want to show non manager nux */
          />
        </div>
      </div>
    );
  }
}

export default ActivitiesClass;



// WEBPACK FOOTER //
// ./src/payments/components/ActivitiesClass.jsx